@if (tree(); as t) {
  <header class="atmos-page__header">
    <h1 class="atmos-page__title">{{ title() || 'Spirit tree' }}</h1>
  </header>

  <section class="atmos-card atmos-tree-view__card">
    <div class="atmos-tree-view__inner">
      <app-spirit-tree [tree]="t"></app-spirit-tree>
    </div>
  </section>
}
